"use client";

import React, { useEffect, useState } from "react";
import appStyle from "../styles/app.module.css";
// import styles from "../styles/termsAndConditions.module.css";
import styles from "@/app/blog/app.module.css";
import images from "../constants/images";

export default function TermsAndConditionsPageContent() {
  // Navigation component - only rendered on desktop

  return (
    <div className={appStyle.container}>
      <div className={styles.blogContent}>
        {/* Main content section */}
        <div>
          <h1 className={styles.mainHeading} id="introduction">
            Terms & Conditions
          </h1>
          <div className={styles.introText}>
            <p className={styles.paragraph}>
              Welcome to MyWeddinglyInvites. By accessing and using our
              platform, you agree to comply with and be bound by the following
              terms and conditions. These terms govern your use of our digital
              wedding invitation services, including all features,
              functionalities, and support provided by us. Please read them
              carefully before proceeding with any purchase.
            </p>
          </div>

          <h2 className={styles.sectionHeading}>Service Scope</h2>
          <p className={styles.paragraph}>
            We provide digital wedding invitations, including video invites and
            related design services, based on the details shared by the
            customer.
          </p>

          <h2 className={styles.sectionHeading}>Revisions Policy</h2>
          <ul className={styles.list}>
            <li>
              One round of textual corrections is included in the initial draft.
            </li>
            <li>
              Any additional changes requested after the first draft/video is
              delivered will be chargeable.
            </li>
            <li>
              Design changes are not included unless explicitly agreed upon and
              may incur additional charges.
            </li>
          </ul>

          <h2 className={styles.sectionHeading}>Payment Terms</h2>
          <ul className={styles.list}>
            <li>
              Orders may begin with partial or full payment, as communicated
              during the purchase process.
            </li>
            <li>
              In case of partial payment, the full payment remains applicable
              even if the customer chooses to discontinue the order after work
              has commenced.
            </li>
          </ul>

          <h2 className={styles.sectionHeading}>Delivery Timeline</h2>
          <p className={styles.paragraph}>
            The first draft will typically be shared within the communicated
            timeframe. Delays caused due to incomplete or incorrect information
            from the customer will not be the responsibility of
            MyWeddinglyInvites.
          </p>

          <h2 className={styles.sectionHeading} id="refund">
            Refund & Cancellation Policy
          </h2>
          <h3 className={styles.subHeading}>No Cancellation / No Refund</h3>
          <p className={styles.paragraph}>
            Once an order is placed and work has commenced, the amount paid is
            non-refundable, regardless of whether the customer chooses to
            continue or not.
          </p>

          <h3 className={styles.subHeading}>Duplicate Payment Refunds</h3>
          <ul className={styles.list}>
            <li>
              Refunds are only applicable in cases of duplicate payments due to
              technical errors.
            </li>
            <li>The duplicate amount will be refunded after verification.</li>
          </ul>
        </div>

        {/* Right navigation section - only on desktop */}
      </div>
    </div>
  );
}
